import { getSessionRequest, getSessionsRequest, addActiveProctor, removeActiveProctor } from './SessionActions';
import { setApplicantNeedAttention, setApplicantProctoringHandles } from '../Applicant/ApplicantActions';
import { displayErrors } from '../Error/ErrorActions';

export default function socketListner(socket, dispatch, intl, getUser = () => null) {
    // Session

    // Refresh sessions for administrators on update
    socket.on('session/updated', data => {
        if(!data.roles || data.roles.includes((getUser() || {}).role)) {
            dispatch(getSessionRequest(data.session)).then(session => {
                if(session) {
                    // intl && displayErrors('success', intl.formatMessage({
                    //     id: 'sessionUpdateSuccessAlert',
                    //     defaultMessage: 'Session {session} updated!',
                    // }, { session: session.label }));
                }
            });
        }
    });

    // Refresh sessions for administrators on publish
    socket.on('session/published', data => {
        if(!['student'].includes((getUser() || {}).role) && (!data.roles || data.roles.includes((getUser() || {}).role))) {
            dispatch(getSessionRequest(data.session));
            // .then(session => {
            //     session && intl && displayErrors('success', intl.formatMessage({
            //         id: 'sessionPublishedSuccessAlert',
            //         defaultMessage: 'Session {session} has been published!',
            //     }, { session: session.label }));
            // });
        }
    });

    socket.on('session/proctor/active', data => {
        if(data.session && data.proctor) {
            dispatch(addActiveProctor(data.session, data.proctor));
        }
    });

    socket.on('session/proctor/unactive', data => {
        if(data.session && data.proctor) {
            dispatch(removeActiveProctor(data.session, data.proctor));
        }
    });

    socket.on('session/activity/set', data => {
        if(data.session) {
            // dispatch activity update (like proctor handle)
            if(data.applicantsProctoringHandles) {
                dispatch(setApplicantProctoringHandles(data.session, data.applicantsProctoringHandles, data.proctor));
            }
            // already set by applicant/live/needattention socket call
            // if(data.applicantsNeedAttention) {
            //     data.applicantsNeedAttention.forEach(attention => dispatch(setApplicantNeedAttention(attention.applicant, attention.needAttention, attention.attentionType)));
            // }
        }
    });
}
